import { createPlugin } from '@backstage/core-plugin-api';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { DisclaimerBanner } from './DisclaimerBanner';

export const techDocsAddonDisclaimerBannerPlugin = createPlugin({
  id: 'techdocs-addon-disclaimer-banner',
});

export const TechdocsDisclaimerBanner = techDocsAddonDisclaimerBannerPlugin.provide(
  createTechDocsAddonExtension({
    name: 'TechDocsDisclaimerBanner',
    location: TechDocsAddonLocations.Subheader,
    component: DisclaimerBanner,
  }),
);
